import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4e35945d6b7e/components/sections/BranchSolutionsShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4e35945d6b7e/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8de4e35945d6b7e/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4e35945d6b7e/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4e35945d6b7e/components/sections/UseCasesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/app/[locale]/branches/shared-branch.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/node_modules/next/dist/client/link.js");
